import { WarningCircleIcon } from "@phosphor-icons/react/WarningCircle";
import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import BranchesDropdown from "@/Shared/Branches/Dropdowns/BranchesDropdown";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import BookShipmentSection from "../CustomComponents/BookShipmentSection";

interface BranchesPanelProps {
  branchId: string | undefined;
  onBranchIdChanged: (newValue: string | undefined) => void;
  index: number;
  branches: SavedLocation[];
  errorMessage: ErrorMessageType;
  forceValidation: boolean;
}
function BookShipmentBranchesPanel(props: BranchesPanelProps) {
  // If there aren't any branches, then it makes no sense to pick a branch
  if (props.branches.length === 0) {
    return <></>;
  }

  return (
    <BookShipmentSection
      index={props.index}
      header={<>Branch</>}
      description="Your company has multiple branches, and you are not coded to a branch. Please select the branch you are booking this for."
    >
      <Panel collapseOnNarrow>
        <Stack gap={2}>
          <T size="base" weight="bold">
            Branch
          </T>
          <BranchesDropdown
            branchId={props.branchId}
            setBranchId={function (value) {
              props.onBranchIdChanged(
                value === "no_branch_assigned" ? undefined : value,
              );
            }}
            branches={props.branches}
          />
          {/* The branch requirement blocks booking, so it must be shown here —
              otherwise the user only sees the generic "correct the above
              errors" banner. */}
          {props.forceValidation && props.errorMessage && (
            <Row gap={2}>
              <Icon icon={WarningCircleIcon} weight="fill" color="text-red" />
              <T size="lg" weight="medium" color="red">
                {props.errorMessage}
              </T>
            </Row>
          )}
        </Stack>
      </Panel>
    </BookShipmentSection>
  );
}
export default BookShipmentBranchesPanel;
